import { compose, createSelector } from '@reduxjs/toolkit';

import { convertMapBoundsToBbox } from '@/microfrontends/map/shared/utils/map/convertMapBoundsToBbox';

import {
  type TJsonQuery,
  insertBboxToJsonQuery,
  insertPageToJsonQuery,
  insertSortToJsonQuery,
} from '@/packages/JsonQuery';

import { useReduxSelector } from '../../../hooks';
import { type TReduxState } from '../../../types';
import {
  activePinPageSelector,
  activePinSortSelector,
  mapSelectedBoundsSelector,
} from '../../mapControls/selectors/dumb';

import { filtersSelector, listingSortSelector, pageSelector } from './dumb';

export const completeJsonQuerySelector = createSelector(
  [filtersSelector, listingSortSelector, pageSelector, mapSelectedBoundsSelector],
  (filters, sort, page, selectedBounds) => {
    const jsonQuery: TJsonQuery = { ...filters };
    let bbox;
    if (selectedBounds) {
      const { topLeft, bottomRight } = convertMapBoundsToBbox(selectedBounds);

      bbox = [
        [topLeft.lng, topLeft.lat],
        [bottomRight.lng, bottomRight.lat],
      ] as [[lngMax: number, latMin: number], [lngMin: number, latMax: number]];
    }

    compose(insertPageToJsonQuery(page), insertSortToJsonQuery(sort), insertBboxToJsonQuery(bbox))(jsonQuery);

    return jsonQuery;
  },
);

export function useCompleteJsonQuerySelector(): TJsonQuery {
  return useReduxSelector(completeJsonQuerySelector);
}

export const completeJsonQueryByPinSelector = createSelector(
  [filtersSelector, activePinSortSelector, activePinPageSelector],
  (filters, sort, page) => {
    const jsonQuery: TJsonQuery = { ...filters };

    compose(insertPageToJsonQuery(page), insertSortToJsonQuery(sort))(jsonQuery);

    return jsonQuery;
  },
);

export function useCompleteJsonQueryByPinSelector(): TJsonQuery {
  return useReduxSelector(completeJsonQueryByPinSelector);
}

export const completeSimilarOffersJsonQuerySelector = createSelector(
  [filtersSelector, (_state: TReduxState, page: number | undefined): number | undefined => page],
  (filters, page) => {
    const jsonQuery: TJsonQuery = { ...filters };

    compose(insertPageToJsonQuery(page))(jsonQuery);

    return jsonQuery;
  },
);

export const completeClustersJsonQuerySelector = createSelector(
  [filtersSelector, listingSortSelector, pageSelector],
  (filters, sort, page) => {
    const jsonQuery: TJsonQuery = { ...filters };

    compose(insertPageToJsonQuery(page), insertSortToJsonQuery(sort))(jsonQuery);

    return jsonQuery;
  },
);
